const crypto = require('crypto');

//https://velog.io/@neity16/NodeJS-crypto%EB%8B%A8%EB%B0%A9%ED%96%A5-%EC%95%94%ED%98%B8%ED%99%94
//https://gngsn.tistory.com/

module.exports = {
  /* signup 시 password를 보내고 salt와 hashed를 반환 */
  encrypt: async (password) => {
    return new Promise(async (resolve, reject) => {
      try {
        const salt = (await crypto.randomBytes(32)).toString('hex');
        crypto.pbkdf2(
          password,
          salt.toString(),
          1,
          32,
          'sha512',
          (err, derivedKey) => {
            if (err) throw err;
            const hashed = derivedKey.toString('hex');
            resolve({ salt, hashed });
          }
        );
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  },
  /* signin시 저장된 salt와 password를 통해 저장된 값과 같은지 확인용도 */
  encryptWithSalt: async (password, salt) => {
    //console.log(password, salt);

    return new Promise(async (resolve, reject) => {
      try {
        crypto.pbkdf2(password, salt, 1000, 24, 'sha256', (err, derivedKey) => {
          if (err) throw err;
          const hashed = derivedKey.toString('base64');
          //console.log('encryptWithSalt hashed:',hashed);
          resolve(hashed);
        });
      } catch (err) {
        console.log('err:', err);
        reject(err);
      }
    });
  },
};
